import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';

const Navbar = () => {
  const [navbarBg, setNavbarBg] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setNavbarBg('bg-white shadow-lg');
      } else {
        setNavbarBg('');
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-colors duration-300 ${navbarBg}`}>
      <div className="container mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center space-x-3">
          <img
            src="/logo.png"
            alt="Logo"
            className="h-10 w-10 bg-red-500 rounded-full object-contain"
          />
          <a className="text-black font-bold text-2xl" href="#home">
            Shiv Shakti Travels
          </a>
        </div>

        {/* Hamburger Icon */}
        <button className="block md:hidden text-black" onClick={toggleMenu}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7" />
          </svg>
        </button>

        {/* Mobile Menu (with animation) */}
        <div className={`absolute top-16 left-0 w-full bg-white transition-all duration-300 ease-in-out md:hidden transform ${isMenuOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-95 pointer-events-none'} z-40`}>
          <ul className="flex flex-col space-y-4 px-6 py-4">
            {['home', 'services', 'packages', 'destination', 'footer'].map((section, idx) => (
              <li key={idx}>
                <Link
                  to={section}
                  smooth={true}
                  duration={500}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-black hover:text-red-500 font-semibold cursor-pointer"
                >
                  {section === 'footer' ? 'Contact Us' : section.charAt(0).toUpperCase() + section.slice(1)}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-6">
          {['home', 'services', 'packages', 'destination', 'footer'].map((section, idx) => (
            <Link
              key={idx}
              to={section}
              smooth={true}
              duration={500}
              className="text-black hover:text-red-500 font-semibold cursor-pointer"
            >
              {section === 'footer' ? 'Contact Us' : section.charAt(0).toUpperCase() + section.slice(1)}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
